module.exports = __webpack_public_path__ + "static/media/password.d1a56639.svg";